import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export default function Login() {
  const nav = useNavigate();
  const loc = useLocation();
  const login = useAuth((s) => s.login);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await login(email, password);
      const dest = (loc.state as { from?: string } | null)?.from || '/app';
      nav(dest, { replace: true });
    } catch (e2: unknown) {
      const error = e2 as { response?: { data?: { error?: { message?: string } } } };
      setErr(error?.response?.data?.error?.message || 'Login failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="min-h-screen flex items-center justify-center bg-dgrp-bg-deep px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="text-xs uppercase tracking-[0.3em] text-dgrp-red mb-2 h-display">
            The Disruption Group
          </div>
          <h1 className="text-3xl font-bold text-white h-display">DG Agent Launch</h1>
        </div>

        <form
          onSubmit={onSubmit}
          className="bg-dgrp-bg-panel border border-dgrp-red/20 rounded-lg p-8 space-y-5"
        >
          <div>
            <label className="block text-sm text-dg-mist mb-2">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-dgrp-bg-deep/80 border border-dgal-navy-2 rounded px-3 py-2 text-white focus:outline-none focus:border-dgrp-red"
              autoFocus
            />
          </div>

          <div>
            <label className="block text-sm text-dg-mist mb-2">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-dgrp-bg-deep/80 border border-dgal-navy-2 rounded px-3 py-2 text-white focus:outline-none focus:border-dgrp-red"
            />
          </div>

          {err && (
            <div className="text-sm text-red-400 bg-red-950/30 border border-red-900/40 rounded px-3 py-2">
              {err}
            </div>
          )}

          <button
            type="submit"
            disabled={busy}
            className="w-full bg-dgrp-red text-white font-semibold py-2.5 rounded hover:bg-dgrp-red-hover transition disabled:opacity-50"
          >
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </main>
  );
}
